import { cn } from "@/lib/utils";
import { text } from "@/constants/tailwind-theme";

const ValueItemComponent = ({ title, description, icon }) => (
  <div className="flex flex-col gap-3">
    <div className="flex flex-row items-center gap-3">
      <img className="h-11 w-auto" src={icon} alt="" />
      <h2 className={cn(text.heading2, "text-white")}>{title}</h2>
    </div>
    <p className={cn(text.body1, "text-white/90")}>{description}</p>
  </div>
);

export default ValueItemComponent;
